import React, { useEffect, useRef, useState, useCallback } from 'react';
import { PlaidLink } from 'react-plaid-link';
import { getFundingSources } from '../../services/AccountApi/paymentMethodApi';
import { fetchTokenApi, manualVerifyMicroDeposit, sendBankDetailApi, verifyMicroDeposit, storePlaidError } from '../../services/LinkBankAccount/linkBankAccountApi';
import { NOTIFICATION_MESSAGES } from '../../utils/constant';
import { toastNotify } from '../../utils/toastNotify';

const LinkBankAccount = (props) => {
  const [token, setToken] = useState(null);
  const [plaidModal, setPlaidModal] = useState(false);
  const [microDepositData, setMicroDepositData] = useState(null);
  const [requestedId, setRequestedId] = useState(null);
  const shouldLog = useRef(true);

  const createLinkToken = async (linkToken = null) => {
    let link_token;
    if (linkToken) {
      link_token = linkToken;
    } else {
      const response = await fetchTokenApi();
      link_token = response.data.linkToken;
      setRequestedId(response?.data?.requestId)
    }
    return link_token;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (shouldLog.current) {
        shouldLog.current = false;
        const token = await createLinkToken();
        setToken(token);
      }
    };
    const openModalWithLinkToken = () => {
      if (props?.linkTokenUnverified) {
        setToken(props?.linkTokenUnverified);
        setPlaidModal(true);
      }
    };

    props?.linkTokenUnverified ? openModalWithLinkToken() : fetchData();
  }, [props.bankModalOpen]);

  const manuallyVerifyMicroDepo = async (publicToken, metadata) => {
    let manualVerifyData = {};
    if (microDepositData?.resData?.data?.bankVerificationStatus === 'PlaidUnverified') {
      manualVerifyData = {
        fundingSourceId: microDepositData?.resData?.data?.id.toString(),
        verificationStatus: microDepositData?.metadata?.account?.verification_status ? metadata?.account?.verification_status : '',
        accountName: microDepositData?.metadata?.account?.name,
        accountId: microDepositData?.metadata?.account?.id,
        publicToken: microDepositData?.metadata?.public_token,
      };
    } else {
      manualVerifyData = {
        fundingSourceId: props?.bankVerificationStatus?.fundingSourceId?.toString(),
        verificationStatus: metadata?.account?.verification_status ? metadata?.account?.verification_status : '',
        accountName: metadata?.account?.name,
        accountId: metadata?.account?.id,
        publicToken: metadata?.public_token,
      };
    }
    try {
      if (!Object.keys(manualVerifyData).length) return;
      props?.startLoading();
      const response = await manualVerifyMicroDeposit(manualVerifyData);
      toastNotify('success', response.message);
      const resData = await getFundingSources();
      if (!resData.isError) {
        props?.handleUpdateBanksList(resData);
        setPlaidModal(false);
        if (props?.shouldUpdateList === false) {
          props?.onSuccess(resData);
        }
      }
      props?.stopLoading();
      props.setBankModalOpen(false);
    } catch (error) {
      toastNotify('error', error?.response?.data?.message);
    } finally {
      props?.stopLoading();
      setMicroDepositData(null);
    }
  };

  const onSuccess = async (publicToken, metadata) => {
    let formData = {
      accountId: metadata.account_id,
      publicToken: metadata.public_token,
      account: {
        id: metadata?.account?.id,
        name: metadata?.account?.name,
        mask: metadata?.account?.mask,
        type: metadata?.account?.type,
        subtype: metadata?.account?.subtype,
        verificationStatus: metadata?.account?.verification_status ? metadata?.account?.verification_status : '',
        classType: metadata?.account?.class_type ? metadata?.account?.class_type : '',
      },
      bankName: metadata.institution.name || '',
    };
    try {
      if (formData?.account?.verificationStatus === 'pending_manual_verification') {
        const resData = await sendBankDetailApi(formData);
        const response = await verifyMicroDeposit(resData?.data?.id);
        const token = response?.data?.linkToken;
        if (!resData.isError && props?.shouldUpdateList === true) {
          props.onSuccess(resData);
        }
        setToken(token);
        setPlaidModal(true);
        setMicroDepositData({ resData, metadata });
      } else {
        setToken(null);
        props?.startLoading();
        if (metadata?.account?.verification_status === 'manually_verified') {
          if (
            props?.bankVerificationStatus?.bankVerificationStatus !== 'Verified' &&
            props?.bankVerificationStatus?.bankVerificationStatus !== undefined
          ) {
            let manualVerifyData = {
              fundingSourceId: props?.bankVerificationStatus?.fundingSourceId?.toString(),
              verificationStatus: metadata?.account?.verification_status ? metadata?.account?.verification_status : '',
              accountName: metadata?.account?.name,
              accountId: metadata?.account?.id,
              publicToken: metadata?.public_token,
            };
            try {
              const response = await manualVerifyMicroDeposit(manualVerifyData);
              toastNotify('success', response.message);
            } catch (err) {
              toastNotify('error', err?.response?.data?.message);
            }
          }
        } else {
          await sendBankDetailApi(formData);
          toastNotify('success', 'Bank added successfully.');
        }
        const resData = await getFundingSources();
        if (!resData.isError) {
          props?.handleUpdateBanksList(resData);
          setPlaidModal(false);
        }
        props?.stopLoading();
        props.setBankModalOpen(false);
      }
    } catch (error) {
      props?.onFail();
      toastNotify('error', error?.response?.data?.message);
    } finally {
      props?.stopLoading();
    }
  };

  const onExit = useCallback(
    async (eventName, metadata) => {
      if (eventName) {
        if (eventName?.error_type) {
          // toastNotify('error',metadata?.error_message) // IF we have to set dynamic msg from plaid side.
          toastNotify('error', NOTIFICATION_MESSAGES.PLAID_LINK_ACCOUNT_ERROR);
          let errorData = {
            linkTokenRequestId: requestedId,
            onExitRequestId: metadata?.request_id || null,
            plaidError: JSON.stringify(eventName, metadata?.request_id),
          };

          try {
            const respData = await storePlaidError(errorData);
            setRequestedId(null);
            setPlaidModal(false);
          } catch (error) {
            toastNotify('error', error?.response?.data?.message);
            setRequestedId(null);
            setPlaidModal(false); 
          }
        }
      }
      props?.onFail();
    },
    [requestedId]
  );


  const onEvent = (eventName) => {
    if (eventName === 'TRANSITION_VIEW') {
      props?.startLoading();
    }
  };

  return plaidModal ? (
    <PlaidLink className={props.className} token={token} onSuccess={manuallyVerifyMicroDepo} onEvent={onEvent} onExit={onExit}>
      {'Verify Microdeposit'}
    </PlaidLink>
  ) : (
    <PlaidLink className={props.className} token={token} onSuccess={onSuccess} onEvent={onEvent} onExit={onExit}>
      {'Continue'}
    </PlaidLink>
  );
};

export default LinkBankAccount;
